import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({});

export default theme;
